export const siteConfig = {
  brand: 'BPA Solutions',
  websiteUrl: 'https://www.bpasolutions.au',
  logoUrl: 'https://cloud.sharemyimage.com/2026/07/26/logo_fixed_512_true_png.png',
  contactEmail: 'support@bpasolutions.au',
  contactPhone: '0425 228 778',
  contactPhoneHref: '+61425228778',
  // External calendar, opened in the SAME tab only after a Gateway-confirmed enquiry.
  // Public URL only. No visitor details or API keys in query parameters.
  bookingUrl: 'https://link.moderncrm.org/widget/bookings/bpa-solutions-initial-consulta',
  // Public settings only; sending credentials remain private inside the existing BPA Email Gateway.
  // This form is registered in the EXISTING BPA Email Gateway V2 Website Forms dashboard.
  // The slug is public. No credentials, Cloudflare, Netlify Functions or Google Apps Script.
  leadEndpoint: 'https://population-coming-bpa-email-gateway-mask.pockethost.io/api/bpa-mail/forms/shelter-enquiry/submit',
  // Universal email forms do not yet support SMS acknowledgements. Keep this off
  // until the Gateway offers this as a configured delivery channel.
  smsAcknowledgementEnabled: false,
  whatsappNumber: '',
  privacyUrl: 'https://legal.bpasolutions.au/#/legal/version/lwgdwsb2ts0nsyb',
  termsUrl: 'https://legal.bpasolutions.au/#/legal/bpa-solutions-service-terms-14-08-2026',
  screenshots: {
    hero: '', dashboard: '', rooms: '', bookings: '', reconciliation: '',
    casework: '', reporting: '', finance: '', automation: '', websites: ''
  },
};